interface Bookmark {
  userId: number;
  projectIds: number[];
}

export function getAllBookmarks(): Bookmark[] {
  const allBookmarks: { userId: number; projectIds: number[] }[] = JSON.parse(
    localStorage.getItem('bookmarks') || '[]'
  );
  return allBookmarks;
}

export function getBookmarks(userId?: number): number[] {
  const allBookmarks = getAllBookmarks();
  const myBookmarks = allBookmarks.find((bookmark) =>
    userId ? bookmark.userId === userId : false
  );
  return myBookmarks ? myBookmarks.projectIds : [];
}
